/**
 * @generated SignedSource<<9872d204557896a8d2b8e3404bc59583>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LegacyScriptTagSettingTabContainer_site$data = {
  readonly id: string;
  readonly embedTag: string | null;
  readonly robeeTag: string;
  readonly " $fragmentType": "LegacyScriptTagSettingTabContainer_site";
};
export type LegacyScriptTagSettingTabContainer_site = LegacyScriptTagSettingTabContainer_site$data;
export type LegacyScriptTagSettingTabContainer_site$key = {
  readonly " $data"?: LegacyScriptTagSettingTabContainer_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"LegacyScriptTagSettingTabContainer_site">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LegacyScriptTagSettingTabContainer_site",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "embedTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "robeeTag",
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};

(node as any).hash = "edd61616c352bafca75a29b3254dea21";

export default node;
